import { getUserAttributes } from '@noths/polaris-client-user-configuration';

import type { Environment } from 'client-site-chrome-ui/environment';
import { mergeBasket as handleMergeBasket } from 'client-site-chrome-ui/services/basket';
import type { Cookies } from 'client-site-chrome-ui/types/cookies';

const ANONYMOUS_BASKET_COOKIE = 'anon_basket_id';
const cookieDomain = {
  production: '.notonthehighstreet.com',
  staging: '.noths.com',
  oldstaging: '.noths.com',
  qa: '.public.{ENV_NAME}.qa.noths.com',
  development: 'localhost',
};

export const handleAnonymousBasket = async (
  env: Environment,
  mergeBasket: boolean,
  cookies?: Cookies,
) => {
  if (!cookies) {
    console.warn('No cookies provided to handleAnonymousBasket');
    return;
  }
  try {
    const { authenticated, identityId } =
      await window.Amplify.default.Auth.currentUserCredentials();

    const attributes = await getUserAttributes();

    const idToken = attributes?.idToken;

    if ([authenticated, identityId].includes(undefined!)) {
      throw new Error('authenticated status or identityId missing');
    }

    if (!authenticated) {
      cookies.set(ANONYMOUS_BASKET_COOKIE, identityId, {
        domain: cookieDomain[env],
        path: '/',
      });
      return;
    }

    const anonymousBasketId = cookies.get(ANONYMOUS_BASKET_COOKIE);

    if (anonymousBasketId && mergeBasket) {
      const success = await handleMergeBasket(env, anonymousBasketId, idToken);

      if (success) {
        cookies.remove(ANONYMOUS_BASKET_COOKIE);
      }
    }
  } catch (error) {
    console.warn('Unable to merge baskets', error);
  }
};
